import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['entities', 'basket'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.USER_PREFERENCES_BASE_URI}/entities/basket`,
        }),
        treatListResponse: (response) =>
          response.data.user_entities_basket.entities_list,
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'entities/basket',
    store,
  });

  basePlugin.onInit(() => {
    store.dispatch('entities/basket/initItems');
  });
};
